import { Table } from '@tanstack/react-table';
import { ReactElement } from 'react';

import { Button } from './Button';

type TablePaginationHeaderProps<T> = {
  tableInstance: Table<T>;
  action?: ReactElement;
  handleRefresh?: () => void;
};

const TablePaginationHeader = <T,>({
  tableInstance,
  action,
  handleRefresh,
}: TablePaginationHeaderProps<T>) => {
  const { getState, getRowModel, getRowCount } = tableInstance;

  const {
    pagination: { pageSize, pageIndex },
  } = getState();

  const { rows } = getRowModel();

  const itemStart = pageIndex * pageSize + 1;
  let itemEnd = itemStart - 1 + pageSize;

  if (itemEnd > getRowCount()) {
    itemEnd = getRowCount();
  }

  return (
    <div className="flex items-center justify-between px-5 py-2 sm:px-10 sm:py-5">
      <div className="w-full sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div className="flex flex-col items-start justify-center gap-2.5 md:flex-row">
          <div className="flex w-full items-center justify-between gap-2.5 sm:w-auto sm:justify-start">
            <p className="text-sm text-primaryGray">
              Showing{' '}
              {rows.length > 0 && (
                <>
                  <span className="font-medium">{itemStart}</span> to{' '}
                  <span className="font-medium">{itemEnd}</span> of{' '}
                </>
              )}
              <span className="font-medium">{getRowCount()}</span> results
            </p>
            <Button
              text="Refresh"
              onClick={handleRefresh}
              className="self-end font-medium sm:hidden"
            />

            <select
              className="hidden rounded-md border border-gray-300 bg-white p-2 pr-10 text-sm font-medium text-primaryGray hover:bg-gray-50 sm:block"
              value={tableInstance.getState().pagination.pageSize}
              onChange={(e) => {
                tableInstance.setPageSize(Number(e.target.value));
              }}
            >
              {[25, 100, 250].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  {pageSize}
                </option>
              ))}
            </select>
          </div>
          <div className="flex flex-wrap items-center gap-2.5">{action}</div>
        </div>
      </div>
    </div>
  );
};

export default TablePaginationHeader;
